var exports = {
  "mc": "Container__lE-Zpt",
  "Y9": "Header__1J6HEX",
  "fI": "Row__XUIP1P",
  "JU": "Label__WmzCP-",
  "xl": "ValueWithIcon___ImsRi",
  "WT": "Value__VK8E1w",
  "N_": "Link__L-YxKN",
  "jd": "DocLink__1SienO",
  "cG": "Divider__5vAgp2",
  "Mn": "DigestInline__NU-LjC",
  "Io": "DigestValue__N3a0KQ",
  "D7": "DigestLabel__UVjk15",
};

module.exports = exports;
